<template>
  <article>
    <section class="xbed-sub-title">
      <span>途家渠道房型详情</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>OTA</BreadcrumbItem>
        <BreadcrumbItem>途家渠道列表</BreadcrumbItem>
        <BreadcrumbItem>途家渠道房型详情</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <Tabs class="tabs" @on-click="toggleTab" style="margin-top: 20px">
      <TabPane label="渠道房型信息" name="roomTypeInfo">
        <room-type-info :data="roomTypeInfo"></room-type-info>
      </TabPane>
      <TabPane label="打包信息" name="packagingInfo">
        <packaging-info :data="packagingInfo"></packaging-info>
      </TabPane>
      <TabPane label="打包列表" name="packagingList">
        <packaging-list ref="packagingList" :unbindRoomList="packagingList.unbindRoomList" @openUnbindRoomListModal="getUnbindRoomList"></packaging-list>
      </TabPane>
    </Tabs>
  </article>
</template>

<script>
import Utils from "@/utils";
import API from "@/api";

import roomTypeInfo from "./room-type-info"
import packagingInfo from "./packaging-info"
import packagingList from "./packaging-list"

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.roomTypeId = Utils.getUrlParameterByName("roomTypeId");
  },
  mounted() {
    this.$Notice.config({
      top: 200
    });
    this.toggleTab(this.currTabName);
  },
  data() {
    return {
      currTabName: "roomTypeInfo",
      roomTypeInfo: {},
      packagingInfo: {},
      packagingList: {
        unbindRoomList: [],
      }
    };
  },
  methods: {
    toggleTab(tabName) {
      this.currTabName = tabName;
      this.queryRoomTypeData();
    },
    queryRoomTypeData() {
      
    },
    async getUnbindRoomList() {
      let resp = (await API.omsAPI[this.env].ota.queryUnbindRoomList(this.roomTypeId, this.token, this.env)).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: resp.msg
        });
        return;
      }

      this.packagingList.unbindRoomList = [...resp.roomList];

      this.$nextTick(() => {
        this.$refs.packagingList.queryUnbindRoomList();
      })
    }
  },
  components: {
    'room-type-info': roomTypeInfo,
    'packaging-info': packagingInfo,
    'packaging-list': packagingList
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ota/tujia/roomtype-detail/index.vue